import { useIntl } from 'react-intl';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { SettingsBreadcrumbs } from '../../containers/Settings/SettingsBreadcrumbs';
import { configurationChangelogPath } from './routes';

type ConfigurationChangelogDetailHeaderProps = Pick<
  HeaderProps,
  'scrollableDivRef'
> & {
  objectName: string;
  versionDate: string;
};

export const ConfigurationChangelogDetailHeader = ({
  objectName,
  versionDate,
  ...props
}: ConfigurationChangelogDetailHeaderProps) => {
  const intl = useIntl();

  return (
    <Header
      {...props}
      breadcrumbs={
        <SettingsBreadcrumbs
          breadcrumbs={[
            {
              to: configurationChangelogPath(),
              label: intl.formatMessage({
                id: 'features.configurationChangelog.header.title',
              }),
            },
            ...(objectName ? [{ label: objectName }] : []),
            ...(versionDate ? [{ label: versionDate }] : []),
          ]}
        />
      }
      title={versionDate}
      description={null}
    />
  );
};
